import { css } from 'design'
import React from 'react'

import { CommunicationOptions } from '../../components/live_chat_widget/communication_options'
import { PoweredByFooter } from '../../components/live_chat_widget/powered_by_footer'
import { WelcomeMessage } from '../../components/live_chat_widget/welcome_message'
import { WidgetHeaderBar } from '../../components/live_chat_widget/widget_header_bar'

export const WelcomePage = () => {
  return (
    <>
      <WidgetHeaderBar>
        <WelcomeMessage />
      </WidgetHeaderBar>
      <div className={spacerStyles()} />
      <CommunicationOptions />
      <PoweredByFooter />
    </>
  )
}

const spacerStyles = css({
  flexGrow: 1,
})
